// 引入二次封装
import request from "@/utils/request.js";

// // 导出get请求的接口方法
// export function myget(params) {
//   return request({
//     url: "xxx",
//     method: "get",
//     params,
//   });
// }

// // 导出post请求的接口方法
// export function mypost(data) {
//   return request({
//     url: "xxx",
//     method: "post",
//     data,
//   });
// }



// 获取站内信息列表
export function userBookList(token,data) {
  return request({
    url: "/api/user/book_list",
    method: "post",
    data,
    headers:{ token }
  });
}

